import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'WorldLayout27',
  width: 0,
  height: 0,
  x: 50,
  y: 100,
  list: [
    {
      id: '1',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2',
      type: 'Container',
      name: 'backgrounds',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '3',
      type: 'Container',
      name: 'nodesContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '4',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '5',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1',
      data: ''
    },
    {
      id: '6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_1',
      parent: '2',
      data: ''
    },
    {
      id: '7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1350,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_2',
      parent: '2',
      data: ''
    },
    {
      id: '8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2700,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_3',
      parent: '2',
      data: ''
    },
    {
      id: '9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4050,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_4',
      parent: '2',
      data: ''
    },
    {
      id: '10',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5400,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_5',
      parent: '2',
      data: ''
    },
    {
      id: '9f0cb310-b23d-4e3f-b2a4-8ab9baf4013b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6750,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_6',
      parent: '2',
      data: ''
    },
    {
      id: '12',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8100,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_7',
      parent: '2',
      data: ''
    },
    {
      id: '13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9450,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'map27_export_8',
      parent: '2',
      data: ''
    },
    {
      id: '56df0195-6463-44b9-940d-5d3496e6e0cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 310,
      y: 584,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cfc191e5-de8a-4d31-a9e5-4acd1efd8ee4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 405,
      y: 574,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bc5fc7ca-9fee-4b06-8282-f06da2a7558c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 480,
      y: 524,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ffe93f63-1d88-4670-8c40-405ce0801a88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 542,
      y: 462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '343ff901-a19d-462b-9c7d-dfdd00b43956',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 636,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '539bd34c-d88d-44e7-8493-d0cc21ae63ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 719,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f77810e6-97d4-4c6c-8433-bdd5aaca1051',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 808,
      y: 505,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '759cdf8e-ee7c-4056-97a4-9c125d95f2a1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 889,
      y: 467,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '17af076b-edab-41a5-a687-af63bb786c48',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 925,
      y: 394,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd08cff26-fd82-4290-a72c-fb334139f8a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1004,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4b373e88-c863-4d38-86f6-3aefaf1ebbd7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1094,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0624709d-8421-4821-82d6-0f6065cf17eb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1154,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6fbe7647-bb86-40a1-9053-46bb27233afe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1237,
      y: 461,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e4a115c2-a6dc-460d-bbfd-2de34276ff14',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1328,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e9a66cb-3bac-416c-975f-4d6a8557fe2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1420,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '2a439cef-8087-464f-99be-712ef9983e3f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1496,
      y: 350,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '97695095-0d11-4253-8fa6-15db9f752386',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1573,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e45f2088-2a6e-4ac4-9b00-0925ba3722bf',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1647,
      y: 249,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a36a0bd3-d2fe-4632-8cfd-c2a6ee5cd51f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1731,
      y: 210,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9e038698-4abd-447c-8507-99bcd470e4d3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1823,
      y: 232,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cba8275a-4e48-4290-8a3d-fd0662801d01',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1898,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ca1462f8-a456-4229-9f21-331e3db1bb0c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1963,
      y: 347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f77c6d15-69c3-45aa-b7f7-619cdb6d97c5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2030,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '449a5a86-35a9-444b-8f2d-0b2e6a55d32b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2120,
      y: 437,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '570d6301-e839-440f-bf2f-d6195b691a1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2220,
      y: 432,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '84812713-f015-4d26-ad54-2897802a3fba',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2304,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f612caa5-3852-4934-8a9f-3b4737bd6dcb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2375,
      y: 327,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b93cc8a2-04c5-42f2-bc93-709b7de516d7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2464,
      y: 289,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5951798b-2602-447d-97f5-8eef9e1ab0bd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2561,
      y: 302,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4ef67fd9-4d68-4c56-9e8a-cbd48b9f0e31',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2645,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1fe5cef9-cd0d-437a-a893-3e8d8ed7adbd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2731,
      y: 391,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '169177a1-aa5f-47ab-8099-14e28944cf84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2826,
      y: 417,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4f0f2879-140c-4654-947c-10bb15918660',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2906,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ea562c21-cd1c-4af4-a547-67f22d0cc0ac',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2986,
      y: 312,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5222865b-6fde-424b-9430-bcd4559f256d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3068,
      y: 268,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'eeeab453-809b-4a52-8518-3571d663b097',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3159,
      y: 239,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '33af62ef-3bb5-435f-bed8-f0d883635f02',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3242,
      y: 274,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4a7f3e5e-125d-4434-9c0c-481e074717ab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3324,
      y: 322,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '999b02e0-39cb-4e19-ad21-662b46924c91',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3411,
      y: 351,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1a7c9dc1-792a-4a6e-8d9c-f43d8263d184',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3504,
      y: 317,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '420cbe67-b67c-4c8b-85ea-e4125e3b1e0c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3592,
      y: 348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e97ab591-87fe-4d63-b8a0-43f6d3abdbe4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3684,
      y: 362,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '19f1fb8f-0f7e-44dc-991a-4172979ce1f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3779,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ea29bf66-0caf-4808-b84e-ba9eaf5dfbed',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3872,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '17ce2f2d-e7e7-42f3-9bec-95821e25819a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3979,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e23c953-3b01-4300-84f6-67c78b5a6a25',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4062,
      y: 337,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ed6dcb5e-b24c-449e-84af-839588f519f7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4143,
      y: 380,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd7ab6f29-e004-4abf-b72e-15ef937fcb4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4233,
      y: 345,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '8dae5e3e-8ba3-4e2a-a182-26b5227b6e0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4321,
      y: 376,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a4268723-5fa4-4166-9dee-9b2cdeca8650',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4407,
      y: 412,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bae6d98b-9355-495a-8c07-69b64a36abff',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4497,
      y: 425,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '427249a5-f47a-47b4-8091-579d3d2bfc7d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4592,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b4bbf245-2694-4c02-bfe9-a19678a8b673',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4677,
      y: 381,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b0c9e48f-7a2f-43f7-a5de-67f7e56e4001',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4757,
      y: 342,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'cc30825b-9d63-4cf3-a2f0-bd05fd4627b5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4847,
      y: 307,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'df9aaeb1-1206-408d-bd4c-45ab9421cf15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4946,
      y: 311,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '93264a6c-5657-46df-a0bb-6a3371c98d6c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5043,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd6ccafad-300b-4d42-bc49-e549f2497d7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5140,
      y: 306,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e5672f0f-4e75-48bf-ae47-a5fa99eca00a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5242,
      y: 326,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'e6f7a01d-88c7-4397-b77c-1647f7a40154',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5333,
      y: 352,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f3170479-954d-4820-a07a-88fe9b301d32',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5406,
      y: 415,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1b05e178-f011-4074-b8fe-bcee3cd4cc08',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5481,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '1de6bbe7-d70f-46c5-bdcb-8599e4c094d5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5553,
      y: 414,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'feb732a0-ce98-4fdb-a9db-bcb8d811255e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5643,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '36537d0c-8ad2-4cf4-8f00-f4b226175535',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5726,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '41a71648-954d-4f8b-9a33-e05bf3fdca96',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5814,
      y: 464,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0361e00b-6253-4d74-89b0-373bbb89d36d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5909,
      y: 455,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6b849561-5717-42e8-9e03-f9889764292e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6005,
      y: 427,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '7a242265-fcb8-497d-9df5-fdc4419b1dc1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6105,
      y: 407,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c7a5d1c1-f29c-40cf-aecc-f255efc2ca15',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6201,
      y: 417,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '40010628-f6f4-45da-8d7c-79a43e6479f9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6302,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'bde4e167-b35d-4a51-83cb-9f1863c00815',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6390,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '83572cf9-00e7-4d6a-87d2-4373f1bf8eab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6480,
      y: 298,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '765c35cb-2e4a-45e5-8645-926f70a2568d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6586,
      y: 285,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'a8ad6a32-8856-42ce-a773-27b82d676147',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6686,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f533b033-a2a4-412e-85dc-76ad6176998f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6785,
      y: 328,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'aea72121-4016-451d-aa3c-9f30e041d1e3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6881,
      y: 356,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c5f16f38-9059-4608-96f8-9d59621f0ab3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6975,
      y: 380,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'df849077-b212-494b-8520-0ac8152efd74',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7073,
      y: 388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9346a043-2e72-4c35-9f70-871a26e19cae',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7161,
      y: 344,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ef5c9f68-7bd0-481b-afe0-0209aee42f5e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7237,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5e78333a-f1d0-4802-9a29-213492652cc4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7334,
      y: 316,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4037521d-7e4d-443b-80e2-a85712172278',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7436,
      y: 336,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '097866a7-7bf0-48cf-b6c3-45fd77b2c353',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7520,
      y: 382,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '0b945e0b-2bdb-44ce-9b64-98e066182d70',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7618,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f951befb-f7ab-4ab7-8d99-353451f3fe82',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7702,
      y: 440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '390a2c41-d860-45cf-9652-0d9aed2d6495',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7802,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '06f9f2c7-a627-4786-a5e6-1aed8b44befe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7892,
      y: 462,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ab94d8b2-49ba-49e0-afc7-4a0c70d9a4c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7967,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '5c6ec63a-c407-46fd-a765-d0b7292bb1f1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8030,
      y: 332,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3ea6482b-4fe3-4802-a4b8-956e07279040',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8105,
      y: 278,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '80ba7797-a348-45b0-9637-32161f519f17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8203,
      y: 261,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'eeba4d03-016a-4190-b2c4-3ceacacfa250',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8296,
      y: 290,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '56c6e888-0035-4438-8e3d-a629ad16c18e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8382,
      y: 331,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4725d106-5edd-4696-8539-b695984e92a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8470,
      y: 365,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd21c8829-84be-4b4a-b14b-5cdcc168bf43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8570,
      y: 374,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '32dd6c7a-057e-4c92-b71f-ec5bf16630de',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8669,
      y: 371,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'c1a4c4f7-7727-4749-9bea-0c31edd7bd9a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8765,
      y: 354,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '9a748bd3-139d-4438-9491-141e37f3a161',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8857,
      y: 379,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6b7c8a72-f2da-43c3-9704-3dacf9e2fc99',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8946,
      y: 410,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '031ca98d-5719-4021-9c7b-83d4bcaa0a0e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9040,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'b524aeba-e80d-4f0a-905f-60f9f81b8e7f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9131,
      y: 377,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4c279f1e-b611-4fc2-a621-a6871c5b9bc3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9226,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '25874f2b-d03c-4f78-96ab-9a7ae381871c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9309,
      y: 403,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '09f91823-24fe-49f1-9bf7-d34c6130aba6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9390,
      y: 447,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'ec70b5bb-8ee1-41af-b785-41807b2ed490',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9465,
      y: 400,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'db47a203-690b-4a0d-bed7-15dd6bdd7909',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9558,
      y: 389,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '59bc7520-a566-4696-989c-809766ad9eb8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9600,
      y: 463,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '51999d99-1dd2-4b8c-a080-5aa6948f5f58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9674,
      y: 513,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '6861986b-2ddb-4cdb-8462-63ed96117ed0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9764,
      y: 534,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'be3e2f07-e9fd-4dda-9d2a-473634bc58b6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9848,
      y: 496,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4622dc98-568c-4084-ac3c-a6500e7ae798',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9910,
      y: 434,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'f6a7cf87-7987-41e8-ae3b-4ea25769ea3b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9967,
      y: 368,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '09adfd7f-5030-4bef-8503-101cc30fa8c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10027,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'fb9e24f5-ff70-4db6-a4ab-c0e9a3423dd8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10125,
      y: 303,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '3bc4bcdd-98ab-48e7-96c5-e6ca2d84ed43',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10197,
      y: 357,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: 'd2393aa3-9474-4cbe-87da-219be8e6fc17',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10255,
      y: 424,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '21314d68-8522-459d-8bf7-eb2f05b6d551',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10322,
      y: 486,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '4fb0e92a-3ad1-466e-a2e1-1d3f7d8ed53e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10415,
      y: 507,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '375e3cec-ec7f-44cd-8990-e21944cb544b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10475,
      y: 436,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blue_node',
      parent: '3',
      data: ''
    },
    {
      id: '74',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '110',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '164',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '185',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '214',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '219',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '224',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '1b355a2e-d409-489c-8af4-a150c082b42b',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'cropsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '4',
      data: ''
    },
    {
      id: '106',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '160',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '181',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '210',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '215',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '220',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '225',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorA',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '230',
      type: 'Container',
      name: '',
      nameSpace: '',
      className: 'signsSectorB',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '5',
      data: ''
    },
    {
      id: '82630176-2990-4416-9aea-7563d486a8a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1735,
      y: 442,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '40afb071-2b27-464c-91c7-b4359cf69784',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1832,
      y: 482,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '76251fe1-3450-499e-8c28-84d704b8521d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1671,
      y: 486,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '9884de58-ef59-4536-b149-97919389df50',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1771,
      y: 525,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ef64cb40-1f39-4505-8f8c-bb962b189433',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1606,
      y: 529,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '91c47e85-3e7e-4d09-9dae-bf68440678f8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1692,
      y: 566,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '9f1f21c5-4287-4833-9912-8d9d87411674',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1537,
      y: 581,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '1abe2627-0dbc-4174-96c2-a2e1e318ba13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1102,
      y: 592,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '84b4029f-67bb-4201-9d3a-e4305b173495',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1203,
      y: 607,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '2979bf18-1ff5-4f88-8710-e5abd8e31f88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1034,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a0dbaa99-1b8e-4590-9a7b-d0604374af8d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1338,
      y: 626,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '57abb7a8-e98e-44cb-9771-35ffeda9e803',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1473,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '7473d76b-3972-45a6-9bf4-06525db39344',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1626,
      y: 623,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '28260b34-2bc1-4e81-bb1f-94fa64f6dc5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1817,
      y: 613,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '65caee8c-c150-4410-84f2-44d6174ca2a8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 961,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a822ee7f-db96-44fb-9f2c-2ccbe78f4586',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1134,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '650b6d95-404b-49f0-bd30-e3b3c03f429d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1272,
      y: 676,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c44a3a79-eb53-4130-b79e-c936348d88b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1410,
      y: 690,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '7dad370e-f64e-4e2e-97e5-793614a5c504',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1562,
      y: 681,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e0810a70-e3a8-4ce6-a6d6-20731399be21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1751,
      y: 661,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '703e29e6-3e56-4b71-bf26-db99924123ef',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 886,
      y: 750,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'e5f5241c-3a41-45a8-8c1f-b081f7695eea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1060,
      y: 724,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'c7ece4b9-671f-4915-8bbf-b87f6603d573',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1208,
      y: 730,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f6195dcc-23ea-43c9-9209-ae55341e11e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1347,
      y: 736,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '37bec314-77bc-478c-9439-10b4de06b113',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1500,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'ee7c8f4d-7590-4188-b2d4-3afca5f23270',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1685,
      y: 712,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '9d639ce8-62a3-425b-8efe-4de9a3a78881',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 987,
      y: 798,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '34cf264e-1ea9-47e9-80bd-6b50deed306a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1134,
      y: 787,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '1a5834b1-6bac-4a13-a521-9850038b30e4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1267,
      y: 805,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '442b6c66-d20d-4ee4-b052-099e8835ec18',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1426,
      y: 800,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b44929ff-49f1-4c1b-ad96-c36778657f4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1604,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '681cd15e-9a29-46a3-a5e9-cef8883c353d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1381,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '51c02820-ed33-4673-b68f-3c797dc06c49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1512,
      y: 63,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '03315082-0196-4302-96d7-a75c87537491',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1707,
      y: 38,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '640aba2d-bb20-4b43-8b8f-3a5c282aa642',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1826,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '6989d525-b561-45ae-b318-af1432909c6c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1941,
      y: 27,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '7ed47892-575a-4659-b547-4cdebc63190d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1275,
      y: 41,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '0c6d0708-6a97-4a95-90d6-3c2029cb43bb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1202,
      y: 82,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '5a5f8163-7827-4431-b0f6-5399f50ce529',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1310,
      y: 92,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'a8dd97eb-e5f7-42c2-9298-84eb9133df7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1443,
      y: 115,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '99b9e8a4-4d38-43e4-b029-b6c7a6e71e0b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1635,
      y: 94,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'cadca758-873a-4eee-ac0a-7a85905e598a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1765,
      y: 95,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '53aa83f5-e376-4a72-9b69-6a9923b13faa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1882,
      y: 83,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '9988004f-7a21-4a88-9238-4d9ba4810079',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1124,
      y: 132,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'd398ddfd-dd0c-4435-8472-3ff7ea228b50',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1242,
      y: 138,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '132a80d8-e076-4242-806b-827b0ce8cd7e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1363,
      y: 164,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f35cc4b5-b0d7-4ea8-8284-792d005736b8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1559,
      y: 143,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '03c91e0d-ebf0-4ccf-a4ec-dc35fff3ba42',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1170,
      y: 191,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '5225cb94-97a8-44d2-bbb9-c0b5d0f766c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1281,
      y: 211,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'b9872cef-1b76-48b8-8058-0f2ffd1eea49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1471,
      y: 199,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '17bd5447-b3b9-4ae6-a708-fbb5185c5719',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1099,
      y: 237,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'bb0da3a8-2b98-439a-ac67-2fff37ae3486',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1205,
      y: 269,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '9a401635-10ef-495b-a392-62be8b4e6753',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1390,
      y: 252,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: 'f7c0db8a-eee9-485b-9e2c-205d85090dfc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1311,
      y: 300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '74',
      data: ''
    },
    {
      id: '77d72e75-1448-4dda-94f1-ba3010d98cfa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2323,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '44c03e42-1a0d-4282-a5f5-c897e6a0780e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2475,
      y: 31,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'dad5523e-bae1-4110-9639-2007b11ecdb3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2591,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '11148d08-d1b7-45b2-98fd-80b1926f4ae9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2649,
      y: 116,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '5646e676-9f24-4533-bfa1-70826712c462',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2261,
      y: 96,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '5540a1d1-df84-4ff7-a886-00b9bc8ef907',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2409,
      y: 82,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '8f5d0da6-dfe0-4070-a25d-6f855012f4be',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2512,
      y: 108,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '20d25338-ad46-4db6-ac61-e7435ee33b84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2578,
      y: 172,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c519e3ba-656c-4fec-8081-525963d7abb9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2196,
      y: 155,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'f586ece9-3ffd-42cd-839b-c108646c7dc9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2336,
      y: 141,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'caaa604d-7957-4feb-9814-1a8b442516b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2446,
      y: 167,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'da900f98-f1ad-4171-9e63-6a5d477ad132',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2261,
      y: 207,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '971b2489-1cf7-45a3-b2be-95d393bceddd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2555,
      y: 475,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'de16d288-a31a-4250-89a0-c3fe648bdcf7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2636,
      y: 523,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '6ee28635-7df4-4910-8c7e-adca2e8caa5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2490,
      y: 516,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '7e6f9c28-7421-422a-b59b-dcc15e2d8d49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2565,
      y: 572,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bfcdf232-4853-4ca7-8f5e-6508fff14f9d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2283,
      y: 576,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'ba804297-5b5e-4db8-b2f6-be443fb8b22f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2408,
      y: 579,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bd242107-6f34-44f5-9020-d470c4cee851',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2487,
      y: 629,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '6d072c62-38c7-4533-baf3-12ff9451f2e5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2611,
      y: 644,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '9fdab58f-ea0f-4e0d-8224-f78649ebcfa1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2197,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '9b1c6508-69ef-431a-bb79-a7105fcdaaa7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2341,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '275a2a24-ba66-40c4-85b0-cf0b5cafcf5d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2421,
      y: 677,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '1123f43f-6c97-41e5-919f-cf2b6726ffb4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2543,
      y: 700,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'bd9225e3-2685-49aa-aef8-66ba62b43640',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2271,
      y: 691,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c3946be6-66aa-4885-8a62-3dc65c8e92a3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2358,
      y: 734,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '393b8621-98b1-4d0e-99e6-50a5cf6e8aca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2475,
      y: 752,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '9b9d5eba-38bd-4bf2-9250-f39274ebef49',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2204,
      y: 742,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: 'c1b1b662-bdae-4f01-a929-2680eb532745',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2288,
      y: 793,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_4',
      parent: '110',
      data: ''
    },
    {
      id: '7613867a-efe7-4e75-93fb-369ac14b471d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3945,
      y: 119,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '7b549f6b-ecc4-4392-ab87-274c984f1618',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4034,
      y: 238,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '16454bda-62e4-4175-a36e-5a746aee512d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3826,
      y: 236,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b27dcef3-aaf8-4a81-957a-1e68e1484f67',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2916,
      y: 53,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'cda27dc7-d857-4cc7-8fc5-175520b54dfd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3022,
      y: 164,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd55c20e0-706d-45da-9fd8-e461a9d70488',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3225,
      y: 46,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd2272a7f-ecbe-495a-973f-bb0ce4f1b76d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2987,
      y: 552,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '2124e531-8b90-4e5d-a7bb-c3d4ecb18c52',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3130,
      y: 489,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '161d6bd9-9233-418e-8d8d-80fa04e6a48d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2952,
      y: 697,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '4166b7cf-b7f4-4bb1-9ff0-fd6b855164c3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3141,
      y: 677,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd363cca7-cc32-4561-8cb1-e807994f06d4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3291,
      y: 546,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'cfd7256e-96e9-45af-8cfd-bf81197d80f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3330,
      y: 696,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '1a12cc4b-85ca-4e29-bc8c-6d5495cc91fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3287,
      y: 178,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '7c2c6c6f-6329-482b-a1dc-1cf04cabbb42',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3356,
      y: 69,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '88afe235-685e-4c2b-a90d-5bc47ac3b8b4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3541,
      y: 61,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '2a4f901d-d0e8-4d73-9c8b-154e93c9e9b0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3466,
      y: 151,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'd2493174-edaf-429e-94ec-8afa4dfef4af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3459,
      y: 260,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '2d0a81b3-052b-4bbc-82d7-3b1bb7fe50cc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3642,
      y: 185,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'a40288b5-98d6-4b41-9b66-dea52b56db7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3664,
      y: 302,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f0ebe0f6-1349-443e-b125-ea7d2909a4b3',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3781,
      y: 52,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'dec3cadc-4c49-4eeb-a52d-af4d18152b58',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2904,
      y: 273,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'f4e85f70-3b3e-4809-948d-566e1f130557',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3916,
      y: 491,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '6b0a0923-8496-47c1-b814-8703231f922c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3814,
      y: 566,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '34359794-419c-495e-9d34-ad5abffbb70d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4040,
      y: 627,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'c0f99c19-0482-4490-8b31-5d2238ff3525',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3801,
      y: 717,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '19749f5a-89a4-4be2-b76a-71d2a82f2433',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3951,
      y: 768,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '6cdd2d2a-e2eb-4fe9-8689-b48e4423e4b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3056,
      y: 775,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: 'b927645a-508a-4561-a50b-7eb40760f1d6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3448,
      y: 783,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '164',
      data: ''
    },
    {
      id: '38d08d8d-9a12-4b37-8f52-85faaf88163d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4342,
      y: 279,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '041b7f07-1fdc-4432-9039-d524b65c750d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4186,
      y: 44,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '932b995f-f1a1-4f63-bed0-175f19a703b2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4291,
      y: 141,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '44f1234b-21d1-42a4-a50a-c7b70045e7fe',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4409,
      y: 64,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: 'd951bee1-9ab8-4c42-a74a-18aedcfd3340',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4470,
      y: 186,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '557e49f4-683c-40b4-a11b-1752f97b200b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4521,
      y: 332,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '32542fb1-86c0-47f4-8b23-5898b72f6461',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4424,
      y: 606,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '025daee2-ebc3-4a0d-ab81-bab9c925e6dc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4335,
      y: 686,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a6683b36-0586-41ac-bb44-ff3735ded96f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4648,
      y: 629,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '5f9e8874-3dab-4358-ac37-59879b24adda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4166,
      y: 771,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '489a48ff-7588-43f4-a9ff-49b7e75e3f00',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4570,
      y: 767,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '7dfe305b-5743-49a4-b74b-2c28509e940d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4859,
      y: 553,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '2b1a6926-fe5f-4f7b-b83d-dc40ae0b7547',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4790,
      y: 692,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '4da29a34-1351-477d-adc5-03b6a745ca8b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5026,
      y: 244,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '949c0581-fdf8-4548-b1ee-9bca3e7d8440',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5035,
      y: 42,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '77809c81-3c5d-41d7-aaf3-3b5cbfdde2c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5134,
      y: 131,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: 'a48ac35c-f5df-48e3-8fce-2a56e7215fdc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5291,
      y: 124,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '65a177bf-82e8-48b0-8722-90611de6378f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5338,
      y: 276,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '02697c9e-c82b-497f-a961-be6466bb2e0f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5062,
      y: 522,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: 'e6c68f16-057e-4d29-b74e-822e0cf35edc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5220,
      y: 529,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '8f16c764-b02d-48ac-a3f4-01a656a4cd4a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5062,
      y: 704,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: 'aa6f7094-2072-4bdb-bc5d-88aef98fe831',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4926,
      y: 770,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '3270c86a-6ae0-4f32-a90e-5ab392b83669',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5307,
      y: 678,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '44e4964c-a8cf-478a-a134-01800ace4cfb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 5202,
      y: 778,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_4',
      parent: '185',
      data: ''
    },
    {
      id: '2dbce353-d6b9-40b5-b282-2b1ee0f7af54',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6659,
      y: 710,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '8708bfaf-70a4-45eb-8312-b331309b36b1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6413,
      y: 725,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: 'faf7204a-4221-4938-b7be-eaf62f6e4c7c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6499,
      y: 551,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '36228088-d4bc-4508-9425-6243d1a624f6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6279,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '015c793b-2367-409b-ba94-cafa96d1db86',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6171,
      y: 293,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '5260ba62-20df-48e0-9f89-e00164f6726f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6431,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '8e455729-fcb2-4534-9316-bd3fb03b7bda',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6229,
      y: 112,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '214',
      data: ''
    },
    {
      id: '07d0db8f-d75b-41df-ab05-92439c2e6094',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7573,
      y: 273,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '75ae3dfe-86dc-4754-910d-55c0dea38292',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7197,
      y: 190,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: 'ac3bf2fc-1b21-4c61-92ac-b1b5667ccf88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7418,
      y: 105,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: 'dfd413d4-0132-434f-bfdf-a385ebd6ed63',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7726,
      y: 99,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: 'deeeb940-d6fe-4a9e-a540-a9af367771ce',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7762,
      y: 300,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '869ceddd-2aa5-4f19-9911-69caafb7feb0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7141,
      y: 656,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '74d4496c-c630-46bf-882b-16d75be29c88',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7368,
      y: 552,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '656d4fd0-de29-45cd-84e9-9cc14f8a2316',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7556,
      y: 632,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '67f8e3b3-1d47-40b0-becd-d2d9b7506a0b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7812,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: 'a39eada7-3ecb-4d82-8953-edd5634e69a6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7970,
      y: 744,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: 'ecf772d5-9c63-4189-8b4c-b90ecba592da',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7681,
      y: 768,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '9c715e0f-3bcb-405d-b8a8-f31bfaa6ba7b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7306,
      y: 762,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_4',
      parent: '219',
      data: ''
    },
    {
      id: '09ae2d44-a165-4d92-ad96-bdde80f5ac2c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8464,
      y: 248,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '6593f497-0c6d-4c53-966a-6983f903d06d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8558,
      y: 161,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'eda81d4b-5380-49bc-ad0e-f114a1bccbab',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8651,
      y: 84,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '651418b4-7615-4a96-a946-242486a7a6ee',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8740,
      y: 189,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '7fb6b94a-5742-4e3e-a2db-22dd747f3dc4',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8645,
      y: 267,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'f53062dd-cd40-4d3c-a175-0a316c2a73ec',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8898,
      y: 40,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '29b271c5-c8b8-450c-b61a-b94063076d4d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8818,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c15bab83-3d6c-45c6-b139-d62f2e55054e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9068,
      y: 57,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd23f980f-bd7b-4997-ac83-d47f0863ca1e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8991,
      y: 140,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '64f078c4-7c4f-4655-a654-dd15dd351a9b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8890,
      y: 222,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '35d09a5c-76d5-4ae2-b701-839e735b41af',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9239,
      y: 83,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'fad83254-10bf-4675-91b6-b8b5d6f80505',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9170,
      y: 165,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '33561ae0-ec03-42ac-8055-c98cb67633cd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9089,
      y: 216,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'ff27999f-6117-4780-b487-37e9bb3af10a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9011,
      y: 293,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '410f1166-1013-41a3-8296-84575c640473',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9198,
      y: 584,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'db78acdd-c4db-4b1e-b225-512d3b3d1bc1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9288,
      y: 636,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'c560f1db-a377-4806-8136-42cd4a478618',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9367,
      y: 729,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd0aacfb0-ed76-49c3-8196-ebf265611066',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9029,
      y: 619,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'dfe3847a-50c3-4e09-882d-78a576acb9a0',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9123,
      y: 705,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '19e78d8b-7c6a-42f4-b8a7-4dcb7d6e50d8',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9220,
      y: 806,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '48c6e9fe-4d5a-4a01-bb54-0820456ecc44',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8984,
      y: 772,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '1f98801b-75fb-48fa-80ff-22f0b5c568c1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8888,
      y: 663,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '5d7555c4-05ba-4df4-9880-52e3c85cd059',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8791,
      y: 593,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'aa1d15aa-7b08-457f-9092-53a4b5f17e7d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8601,
      y: 594,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'd91200d3-6b94-4995-91d5-97e50c9b7be7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8788,
      y: 792,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: 'fafcf64b-017d-4493-859b-bfec575a24c6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8692,
      y: 672,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '224',
      data: ''
    },
    {
      id: '339e0db6-7aa5-41cd-9ba1-b73417e0bb33',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9930,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '8cc65c8a-a88e-4236-8449-9c4cab4b2e7a',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9850,
      y: 106,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '05c0c4b8-5116-4f03-a3f6-543c1ed443a5',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9760,
      y: 173,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'd26b0299-378a-4390-99c8-d6eaa929fd8f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9679,
      y: 264,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '86d939a9-2039-4922-b569-6898f3bc9bbb',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10082,
      y: 67,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '24fa5598-ca28-4bb1-be23-43b17dcdb225',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10001,
      y: 141,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'c124a136-0370-4011-aadd-08317f968120',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9923,
      y: 206,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '20f14426-41c7-4284-bc8f-173a8eed3d5e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9847,
      y: 287,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'bc2751f4-0926-41b1-b894-56d6b5c29224',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9749,
      y: 363,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'a1de5588-b132-4d23-b731-266437a0b444',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9663,
      y: 694,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '49cc22a7-af44-4ad2-a627-70741d6c4e97',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9566,
      y: 797,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b6401805-9186-4938-a514-6dc1076a99f2',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10057,
      y: 529,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '1d5d8218-4950-437b-a571-5ddd134a3bcc',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9995,
      y: 600,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'cf95b39e-66b7-4ebe-b5c3-3a88df957e4c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9902,
      y: 645,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '7e0bc89a-3de5-46be-a569-84f5d4cdc8c7',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9841,
      y: 738,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '64afdc83-9f2c-4d4e-aeb5-278e48677586',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9763,
      y: 834,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'aff7f718-b7e7-43f8-94c3-6dbc6d116a1f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10179,
      y: 610,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'fdaaa0f0-a33d-438a-9002-713458866bb1',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10117,
      y: 680,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '0794deae-ccba-4a6c-8f70-2d7b9055601c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10023,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '57c2119e-2e0f-4112-b08a-56a3bdcabf24',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10334,
      y: 665,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: 'b728734d-dc71-4232-82d9-bd1304ea2da9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10235,
      y: 756,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '118c34a9-42f7-48da-9c1e-66e99a4d1fa9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 10444,
      y: 785,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_4',
      parent: '1b355a2e-d409-489c-8af4-a150c082b42b',
      data: ''
    },
    {
      id: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 1237,
      y: 272,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '106',
      data: ''
    },
    {
      id: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 2462,
      y: 547,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '160',
      data: ''
    },
    {
      id: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 3905,
      y: 515,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '181',
      data: ''
    },
    {
      id: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 4932,
      y: 622,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '210',
      data: ''
    },
    {
      id: '107',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 6255,
      y: 222,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '215',
      data: ''
    },
    {
      id: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 7432,
      y: 606,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '220',
      data: ''
    },
    {
      id: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 8499,
      y: 550,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '225',
      data: ''
    },
    {
      id: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 9489,
      y: 568,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'crop-sign',
      parent: '230',
      data: ''
    },
    {
      id: 'e9b75b1f-8160-4ef5-b5b9-9efa162189aa',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '85746295-e987-4e2b-a7d0-6791216b55a9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -27,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_harvest_map',
      parent: '2260d25b-22ed-4df5-b6ea-1bcb9caebc8c',
      data: ''
    },
    {
      id: '8760c148-9cef-4f28-9a17-22e855cf0c84',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -16,
      y: -62,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: '656a5808-34d6-4751-a733-6af98d163ac6',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'rapeseed_harvest_map',
      parent: '460cfc1c-9225-4169-8dcb-f719f9865b1d',
      data: ''
    },
    {
      id: 'c001f4bb-2f73-4bf8-8953-deb543c31f21',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: 'c41c933b-373f-4a3d-bdc7-f748ce87c274',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_harvest_map',
      parent: '15ecb407-34dd-49fd-94d1-15dd5136e53f',
      data: ''
    },
    {
      id: '16ac1fb4-d061-449e-87ad-02f0d5dff6e9',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '958851db-006d-425c-afff-a85018a3cb2b',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'hop_harvest_map',
      parent: '44e93875-1962-4c55-ba54-c3293bb0e9ea',
      data: ''
    },
    {
      id: '108',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '107',
      data: ''
    },
    {
      id: '109',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_harvest_map',
      parent: '107',
      data: ''
    },
    {
      id: '46aeb65d-4896-4557-9865-75ef0057e163',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: 'ac0db26e-8010-4059-87b0-18b44d3c25ca',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'nectarine_harvest_map',
      parent: 'f91af2df-8d3d-49a3-8040-33bebb847e55',
      data: ''
    },
    {
      id: '03074616-c479-4d19-9e8c-855582627513',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '018bb44b-6ca0-491c-b479-368ca2fa6897',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_harvest_map',
      parent: 'e5a00353-b3ea-4436-b6f7-619f1dcc42d9',
      data: ''
    },
    {
      id: '2e08b7f7-57a1-4e7c-baf5-459d9f88afdd',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'speech_bubble',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    },
    {
      id: 'c077834a-7855-43ec-a465-2f5ed5df5421',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'blackberry_harvest_map',
      parent: '4f3d25a5-5ef3-4047-a7ae-61f2040e854e',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class WorldLayout27 {
  static raw = raw;
  root: PIXI.Container
  backgrounds: PIXI.Container
  nodesContainer: PIXI.Container
  cropsSectorA: (PIXI.Container)[]
  cropsSectorB: (PIXI.Container)[]
  signsSectorA: (PIXI.Container)[]
  signsSectorB: (PIXI.Container)[]

  constructor() {
    populate(this, raw);
  }
}
